import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AppProvider from "./contexts";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
	<AppProvider>
		<App />
	</AppProvider>
);
